/**
 * ENFAMI — Page équipe (référence visuelle exacte)
 * Subnav + pills + carrousels Saison / Collabs / Retro / …
 */
(function () {
  'use strict';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function normalizeHandle(h) {
    return String(h || '')
      .toLowerCase()
      .replace(/-copie$/, '')
      .trim();
  }

  function findTeam(taxonomy, handle) {
    var h = normalizeHandle(handle);
    var groups = [
      { type: 'club', items: taxonomy.clubs || [] },
      { type: 'nation', items: taxonomy.nations || [] }
    ];
    for (var g = 0; g < groups.length; g++) {
      for (var i = 0; i < groups[g].items.length; i++) {
        var t = groups[g].items[i];
        var list = [t.handle].concat(t.aliases || []).map(normalizeHandle);
        if (list.indexOf(h) !== -1) return { type: groups[g].type, team: t };
      }
    }
    return null;
  }

  function money(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }
    return ((Number(cents) || 0) / 100).toLocaleString('fr-CA', {
      style: 'currency',
      currency: 'CAD'
    });
  }

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[／]/g, '/')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function hay(product) {
    return norm(product.title + ' ' + (product.tags || []).join(' '));
  }

  function hasTag(product, tag) {
    if (!tag) return false;
    return (product.tags || []).some(function (t) {
      return norm(t) === norm(tag);
    });
  }

  function includesAny(text, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (text.indexOf(norm(keys[i])) !== -1) return true;
    }
    return false;
  }

  /* ——— Classification produit (priorité exclusive) ——— */
  function isRetro(text) {
    if (includesAny(text, ['retro', 'vintage'])) return true;
    // Saisons anciennes type 03/04, 96/97, 11/12, 15/16 (hors 24/25, 25/26, 26/27)
    if (/\b(9\d|0\d|1[0-9]|20|21|22|23)\/(\d{2})\b/.test(text)) return true;
    if (/\b(19|20)\d{2}\/(19|20)?\d{2}\b/.test(text) && !includesAny(text, ['2024', '2025', '2026', '24/25', '25/26', '26/27'])) {
      return true;
    }
    return false;
  }

  function isCollab(text) {
    return includesAny(text, [
      'collab',
      'collaboration',
      'olivia',
      'rodrigo',
      'travis',
      'scott',
      'rosalia',
      'drake',
      'coldplay',
      'spotify',
      ' x '
    ]);
  }

  function isSpecial(text) {
    return includesAny(text, [
      'edition speciale',
      'edition special',
      'special edition',
      'edition concept',
      'edition clasico',
      'edition conjointe',
      'limited edition',
      'edition ldc'
    ]);
  }

  function isKids(text) {
    return includesAny(text, ['enfant', 'kids', 'kid', 'bebe', 'junior', 'child']);
  }

  function isWomen(text) {
    return includesAny(text, ['femme', 'women', 'woman', 'crop top']);
  }

  function isKeeper(text) {
    return includesAny(text, ['gardien', 'goalkeeper', ' gk ']);
  }

  function isTraining(text) {
    return includesAny(text, ['training', 'entrainement', 'tracksuit', 'survêtement', 'survetement']);
  }

  function isPrematch(text) {
    return includesAny(text, ['pre-match', 'avant-match', 'avant match', 'prematch']);
  }

  function isLongSleeve(text) {
    return includesAny(text, ['manche longue', 'manches longues', 'long sleeve']);
  }

  function isPlayerEdition(text, product) {
    if (hasTag(product, 'cat:edition-joueur') || hasTag(product, 'pro')) return true;
    return includesAny(text, ['edition joueur', 'player', 'version flocage ldc', 'flocage ldc', 'version player']);
  }

  function isSeason2627(text) {
    return includesAny(text, ['2026/27', '26/27', '26-27', '2026-27']);
  }

  function isSeason2526(text) {
    return includesAny(text, ['2025/26', '25/26', '25-26', '2025-26']);
  }

  function classifySections(product) {
    var text = hay(product);
    var ids = [];

    if (isRetro(text)) ids.push('retro');
    else if (isCollab(text)) ids.push('collabs');
    else if (isSpecial(text)) ids.push('special');

    if (isKeeper(text)) ids.push('gardien');
    if (isTraining(text)) ids.push('training');
    if (isPrematch(text)) ids.push('prematch');
    if (isKids(text)) ids.push('kids');
    if (isWomen(text)) ids.push('women');
    if (isPlayerEdition(text, product)) ids.push('edition-joueur');
    if (isLongSleeve(text)) ids.push('manches-longues');

    // Saison : seulement si pas déjà classé rétro/collab (évite doublons)
    if (!isRetro(text) && !isCollab(text)) {
      if (isSeason2627(text)) ids.push('saison-26-27');
      else if (isSeason2526(text) && !isKids(text)) ids.push('saison-25-26');
    }

    // Si rien : saison 26/27 fallback si année récente absente → "autres"
    if (!ids.length) ids.push('autres');
    return ids;
  }

  function matchesPill(product, pill) {
    if (!pill || pill.id === 'all') return true;
    var text = hay(product);
    if (pill.tag && hasTag(product, pill.tag)) return true;

    if (pill.id === 'home') {
      return includesAny(text, ['domicile', 'home']) && !includesAny(text, ['3eme', '3ème', 'troisieme', 'third', 'fourth', '4eme', 'fifth', '5eme']);
    }
    if (pill.id === 'away') {
      return includesAny(text, ['exterieur', 'away', 'visite']) && !includesAny(text, ['3eme', '3ème', 'troisieme', 'third', '4eme', 'fourth', '5eme', 'fifth']);
    }
    if (pill.id === 'third') {
      return includesAny(text, ['3eme', '3ème', 'troisieme', 'third', 'troisieme exterieur']);
    }
    if (pill.id === 'fourth') {
      return includesAny(text, ['4eme', '4ème', 'fourth']);
    }
    if (pill.id === 'fifth') {
      return includesAny(text, ['5eme', '5ème', 'fifth']);
    }
    if (pill.id === 'retro') return isRetro(text);
    if (pill.id === 'special') return isSpecial(text) || isCollab(text);
    if (pill.id === 'training') return isTraining(text);
    if (pill.id === 'prematch') return isPrematch(text);

    return includesAny(text, pill.keywords || []);
  }

  function detectBadge(product) {
    if (product.badge) return product.badge;
    var text = hay(product);
    if (isPlayerEdition(text, product)) return 'Pro';
    return '';
  }

  function chevron(dir) {
    return dir === 'prev'
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>';
  }

  var CARD_SIZES = '(max-width: 749px) 42vw, 220px';

  function getTrophyAssets() {
    if (window.__efPalmaresTrophies) return window.__efPalmaresTrophies;
    var el = document.getElementById('ef-palmares-trophies');
    var data = { worldcup: '', worldcup2x: '', ucl: '', ucl2x: '' };
    if (el) {
      try {
        data = JSON.parse(el.textContent || '{}') || data;
      } catch (e) {}
    }
    window.__efPalmaresTrophies = data;
    return data;
  }

  function trophyKind(pm) {
    if (pm && pm.kind === 'ucl') return 'ucl';
    if (pm && pm.kind === 'worldcup') return 'worldcup';
    if (pm && pm.type === 'titles') return 'ucl';
    return 'worldcup';
  }

  function trophyImg(kind, size) {
    var assets = getTrophyAssets();
    var src = kind === 'ucl' ? assets.ucl : assets.worldcup;
    var src2x = kind === 'ucl' ? assets.ucl2x : assets.worldcup2x;
    if (!src) return '';
    var px = size || 20;
    var srcset = src2x ? ' srcset="' + src + ' 1x, ' + src2x + ' 2x"' : '';
    return (
      '<img class="ef-palmares__trophy" src="' +
      src +
      '"' +
      srcset +
      ' alt="" width="' +
      px +
      '" height="' +
      px +
      '" loading="lazy" decoding="async">'
    );
  }

  function buildPalmaresHtml(pm) {
    if (!pm || !pm.type) return '';
    if (pm.type === 'text' && pm.value) {
      return (
        '<span class="ef-palmares ef-palmares--text"><span class="ef-palmares__text"></span></span>'
      );
    }
    var n = parseInt(pm.value, 10) || 0;
    if (n < 1) return '';
    var kind = trophyKind(pm);
    var label = kind === 'ucl' ? 'Ligue des champions' : 'Coupe du monde';
    if (n > 4) {
      return (
        '<span class="ef-palmares ef-palmares--count" aria-label="' +
        n +
        ' ' +
        label +
        '"><span class="ef-palmares__text"></span>' +
        trophyImg(kind, 22) +
        '</span>'
      );
    }
    var icons = '';
    for (var i = 0; i < n; i++) icons += trophyImg(kind, 20);
    return (
      '<span class="ef-palmares ef-palmares--trophies" aria-label="' +
      n +
      ' ' +
      label +
      '">' +
      icons +
      '</span>'
    );
  }

  function applyPalmaresText(root, pm) {
    var el = root.querySelector('.ef-palmares__text');
    if (!el || !pm) return;
    if (pm.type === 'text') {
      el.textContent = String(pm.value || '');
      return;
    }
    var n = parseInt(pm.value, 10) || 0;
    if (n > 4) {
      el.textContent = String(n);
    }
  }

  function buildCard(product, format, opts) {
    opts = opts || {};
    var pro = detectBadge(product);
    var a = document.createElement('a');
    a.className = 'etp__card';
    a.href = product.url;
    a.innerHTML =
      '<div class="etp__media">' +
      buildPalmaresHtml(product.palmares) +
      (pro ? '<span class="etp__pro"></span>' : '') +
      '</div>' +
      '<p class="etp__name"></p>' +
      '<p class="etp__price"></p>';
    if (pro) a.querySelector('.etp__pro').textContent = pro;
    applyPalmaresText(a, product.palmares);
    a.querySelector('.etp__name').textContent = product.title;
    a.querySelector('.etp__price').textContent = money(product.price, format);

    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      if (product.srcset) img.srcset = product.srcset;
      img.sizes = CARD_SIZES;
      img.alt = product.title;
      img.width = 400;
      img.height = 500;
      img.decoding = 'async';
      if (opts.eager) {
        img.loading = 'eager';
        img.fetchPriority = 'high';
      } else {
        img.loading = 'lazy';
        img.fetchPriority = 'low';
      }
      var media = a.querySelector('.etp__media');
      media.insertBefore(img, media.firstChild);
    }
    return a;
  }

  /* UI taxonomy embarquée — pas d’attente réseau si force-show */
  var DEFAULT_UI = {
    pill_filters: [
      { id: 'all', label: 'ALL' },
      { id: 'home', label: 'HOME', tag: 'kit:home' },
      { id: 'away', label: 'AWAY', tag: 'kit:away' },
      { id: 'third', label: 'THIRD', tag: 'kit:third' },
      { id: 'fourth', label: 'FOURTH', tag: 'kit:fourth' },
      { id: 'fifth', label: 'FIFTH', tag: 'kit:fifth' },
      { id: 'retro', label: 'RETRO', tag: 'cat:retro' },
      { id: 'special', label: 'SPECIAL EDITION', tag: 'cat:editions-speciales' },
      { id: 'training', label: 'TRAINING', tag: 'cat:entrainement' },
      { id: 'prematch', label: 'PRE-MATCH', tag: 'cat:avant-match' }
    ],
    subnav: [
      { id: 'special', label: 'Édition Spéciale' },
      { id: 'kids', label: 'Enfant' }
    ],
    carousel_sections: [
      { id: 'saison-26-27', label: 'Saison 26/27' },
      { id: 'collabs', label: 'Collabs' },
      { id: 'retro', label: 'Retro' },
      { id: 'special', label: 'Éditions spéciales' },
      { id: 'gardien', label: 'Gardien' },
      { id: 'training', label: 'Entraînement' },
      { id: 'prematch', label: 'Avant-match' },
      { id: 'manches-longues', label: 'Manches longues' },
      { id: 'edition-joueur', label: 'Édition joueur' },
      { id: 'kids', label: 'Enfant' },
      { id: 'women', label: 'Femme' },
      { id: 'saison-25-26', label: 'Saison 25/26' },
      { id: 'autres', label: 'Autres' }
    ]
  };

  function bindArrows(wrap, track) {
    var prev = wrap.querySelector('.etp__arrow--prev');
    var next = wrap.querySelector('.etp__arrow--next');
    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.hidden = track.scrollLeft <= 4;
      next.hidden = track.scrollLeft >= max;
    }
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
      });
    }
    track.addEventListener('scroll', update, { passive: true });
    requestAnimationFrame(update);
  }

  function render(root, taxonomy, products, activePillId) {
    var pillsEl = $('[data-etp-pills]', root);
    var rowsEl = $('[data-etp-rows]', root);
    var subnavEl = $('[data-etp-subnav]', root);
    var emptyEl = $('[data-etp-empty]', root);
    var format = root.getAttribute('data-money-format');
    var viewAll = root.getAttribute('data-view-all-label') || 'Voir Tout';
    var collectionUrl = root.getAttribute('data-collection-url') || '';
    var pills = taxonomy.pill_filters || [];
    var sections = taxonomy.carousel_sections || [];
    var activePill =
      pills.find(function (p) {
        return p.id === activePillId;
      }) || pills[0];

    if (subnavEl && !subnavEl.dataset.ready) {
      subnavEl.dataset.ready = '1';
      if (!subnavEl.children.length) {
        (taxonomy.subnav || []).forEach(function (item) {
          var a = document.createElement('a');
          a.href = '#';
          a.textContent = item.label;
          a.addEventListener('click', function (e) {
            e.preventDefault();
            if (item.id === 'special') root._etpSetPill('special');
            else root._etpSetPill('all');
            setTimeout(function () {
              var el = document.getElementById(item.id === 'kids' ? 'etp-section-kids' : 'etp-section-special');
              if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 80);
          });
          subnavEl.appendChild(a);
        });
      }
    }

    /* Pills : mettre à jour l’état actif (HTML déjà présent ou reconstruit) */
    if (!pillsEl.querySelector('[data-pill]')) {
      pillsEl.innerHTML = '';
      pills.forEach(function (pill) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'etp__pill' + (pill.id === activePill.id ? ' is-active' : '');
        btn.setAttribute('data-pill', pill.id);
        btn.textContent = pill.label;
        btn.addEventListener('click', function () {
          root._etpSetPill(pill.id);
        });
        pillsEl.appendChild(btn);
      });
    } else {
      pillsEl.querySelectorAll('[data-pill]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-pill') === activePill.id);
      });
    }

    var filtered = products.filter(function (p) {
      return matchesPill(p, activePill);
    });

    /* Bucket par section */
    var buckets = {};
    filtered.forEach(function (p) {
      classifySections(p).forEach(function (id) {
        if (!buckets[id]) buckets[id] = [];
        if (buckets[id].indexOf(p) === -1) buckets[id].push(p);
      });
    });

    var sectionList = sections.slice();
    if (activePill && activePill.id !== 'all') {
      if (['retro', 'special', 'training', 'prematch'].indexOf(activePill.id) !== -1) {
        var map = { special: 'special', retro: 'retro', training: 'training', prematch: 'prematch' };
        var onlyId = map[activePill.id];
        sectionList = sections.filter(function (s) {
          return s.id === onlyId || (activePill.id === 'special' && (s.id === 'special' || s.id === 'collabs'));
        });
      }
    }

    rowsEl.innerHTML = '';
    var shown = 0;

    sectionList.forEach(function (section) {
      var items = buckets[section.id] || [];
      if (!items.length) return;
      shown += items.length;

      var row = document.createElement('section');
      row.className = 'etp__row';
      row.id = 'etp-section-' + section.id;

      var head = document.createElement('div');
      head.className = 'etp__row-head';
      head.innerHTML = '<h2 class="etp__row-title"></h2><a class="etp__row-all" href="#"></a>';
      head.querySelector('.etp__row-title').textContent = section.label;
      var allLink = head.querySelector('.etp__row-all');
      allLink.textContent = viewAll;
      allLink.href = collectionUrl;

      var wrap = document.createElement('div');
      wrap.className = 'etp__wrap';
      wrap.innerHTML =
        '<button type="button" class="etp__arrow etp__arrow--prev" aria-label="Précédent">' +
        chevron('prev') +
        '</button>' +
        '<div class="etp__track" data-track></div>' +
        '<button type="button" class="etp__arrow etp__arrow--next" aria-label="Suivant">' +
        chevron('next') +
        '</button>';
      var track = wrap.querySelector('[data-track]');
      var isFirstRow = rowsEl.children.length === 0;
      items.forEach(function (p, idx) {
        track.appendChild(
          buildCard(p, format, { eager: isFirstRow && idx < 4 })
        );
      });
      bindArrows(wrap, track);

      row.appendChild(head);
      row.appendChild(wrap);
      rowsEl.appendChild(row);
    });

    if (!shown && filtered.length) {
      var row2 = document.createElement('section');
      row2.className = 'etp__row';
      row2.innerHTML =
        '<div class="etp__row-head"><h2 class="etp__row-title">Tous les maillots</h2></div>' +
        '<div class="etp__wrap">' +
        '<button type="button" class="etp__arrow etp__arrow--prev" aria-label="Précédent">' +
        chevron('prev') +
        '</button>' +
        '<div class="etp__track" data-track></div>' +
        '<button type="button" class="etp__arrow etp__arrow--next" aria-label="Suivant">' +
        chevron('next') +
        '</button></div>';
      var track2 = row2.querySelector('[data-track]');
      filtered.forEach(function (p, idx) {
        track2.appendChild(buildCard(p, format, { eager: idx < 4 }));
      });
      bindArrows(row2.querySelector('.etp__wrap'), track2);
      rowsEl.appendChild(row2);
      shown = filtered.length;
    }

    if (emptyEl) emptyEl.hidden = shown > 0;
  }

  function boot(root, taxonomy, products) {
    document.documentElement.classList.add('enfami-team-page');
    document.body.classList.add('enfami-team-page');
    root.hidden = false;

    var state = { pill: 'all' };
    root._etpSetPill = function (id) {
      state.pill = id;
      render(root, taxonomy, products, state.pill);
    };

    root.querySelectorAll('[data-etp-pills] [data-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root._etpSetPill(btn.getAttribute('data-pill'));
      });
    });

    render(root, taxonomy, products, state.pill);
  }

  function init() {
    var root = $('[data-enfami-team-page]');
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    var sid = root.getAttribute('data-section-id');
    var productsEl = document.getElementById('enfami-team-products-' + sid);
    var products = [];
    try {
      products = productsEl ? JSON.parse(productsEl.textContent) : [];
    } catch (e) {
      products = [];
    }

    var force = root.getAttribute('data-force-show') === 'true';
    var taxonomyUrl = root.getAttribute('data-taxonomy-url');

    /* force-show : UI locale, pas d’attente fetch → premier paint immédiat */
    if (force) {
      boot(root, DEFAULT_UI, products);
      return;
    }

    if (!taxonomyUrl) return;

    fetch(taxonomyUrl, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (taxonomy) {
        var handle = root.getAttribute('data-collection-handle');
        var match = findTeam(taxonomy, handle);
        if (!match) {
          root.hidden = true;
          document.documentElement.classList.remove('enfami-team-page');
          document.body.classList.remove('enfami-team-page');
          return;
        }
        boot(root, Object.assign({}, DEFAULT_UI, taxonomy), products);
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    var root = $('[data-enfami-team-page]');
    if (root) delete root.dataset.ready;
    init();
  });
})();
